import React from "react";
import gallery_data from "../data/portfolio.json";
import Photo from './Photo.js'
import PhotoPopup from "./photoPopup.js";

import { useState } from "react";

export default function Portfolio() {

    const [open, setOpen] = useState(false)
    const [image, setImage] = useState({})
    const [index, setIndex] = useState(0)
    const [tag, setTag] = useState("")

    const toggleOpen = () => {
        setOpen(!open)
    }

    const selectImage = (data, index, tag) => {
        setImage(data);
        setIndex(index);
        setTag(tag);
        toggleOpen();
    }

    const next = (e) => {
        e.stopPropagation();
        let gallery = gallery_data.tableSetup;
        if (tag === "dangoploof") {
            gallery = gallery_data.dangoploof;
        } else if (tag === "potatostirfry") {
            gallery = gallery_data.potatostirfry;
        } else if (tag === "tableSketch") {
            gallery = gallery_data.tablesketch;
        }

        let nextIndex = (index + 1) % gallery.length;
        let nextImage = gallery[nextIndex];
        setImage(nextImage);
        setIndex(nextIndex);
    }

    const prev = (e) => {
        e.stopPropagation();
        let gallery = gallery_data.tableSetup;
        if (tag === "dangoploof") {
            gallery = gallery_data.dangoploof;
        } else if (tag === "potatostirfry") {
            gallery = gallery_data.potatostirfry;
        } else if (tag === "tableSketch") {
            gallery = gallery_data.tablesketch;
        }


        let nextIndex = (index - 1 + gallery.length) % gallery.length;
        let nextImage = gallery[nextIndex];
        setImage(nextImage);
        setIndex(nextIndex);
    }

    return (
        <div>
            <section className="small-section">
                <div className="welcome-content">
                    <img className="portfolio-img" src="images/tabling/dango_potato_poster_transparent.png" alt="2 girls" />
                    <h1>Hello! We are Allison and Cynthia</h1>
                    <p>
                        We are two sisters based in Georgia, USA! Dango Ploof or Allison loves crocheting many different amigurumi from her favorite games and shows.
                        Potato Stirfry or Cynthia loves drawing and designing prints, keychains, etc. Sometimes she even
                        dabbles in other art side projects like making jewlery or playing around with her 3D pen.
                        We hope you enjoy our work!
                    </p>
                     <div className="button-row">
                        <a href="#dangoartexamples"><button className="button">Allison's Art</button></a>
                        <a href="#potatoartexamples"><button className="button">Cynthia's Art</button></a>
                        <a href="#tablesetup"><button className="button">Table Setup</button></a>
                    </div>
                </div>
            </section>
            <section className="small-section">
                <h1>Portfolio</h1>
                <h2>Art Examples</h2>
                <h3 id="dangoartexamples">Dango Ploof Crochet - Crochet Dolls</h3>
                <div className="card-row">
                    {gallery_data.dangoploof.map((item, index) => (
                        <Photo key={item.title} data={item} tag={"dangoploof"} index={index} showDate={false} selectImage={selectImage} />
                    ))}
                </div>
                <h3 id="potatoartexamples">Potato Stirfry - 2D Art, Prints & Accessories</h3>
                <div className="card-row">
                    {gallery_data.potatostirfry.map((item, index) => (
                        <Photo key={item.title} data={item} tag={"potatostirfry"} index={index} showDate={false} selectImage={selectImage} />
                    ))}
                </div>

                <h2 id="tablesetup">Table Set up</h2>
                <h3>Layout Sketch</h3>
                <p>The plan is the have some cubbies on the table that hold crochet as well as show stickers and prints. The table itself will be used to mainly show crochet.</p>
                <div className="card-row">
                    {gallery_data.tablesketch.map((item, index) => (
                        <Photo key={item.title} data={item} tag={"tableSketch"} index={index} showDate={false} selectImage={selectImage} />
                    ))}
                </div>
                <h3>Past Events</h3>
                <div className="card-row">
                    {gallery_data.tableSetup.map((item, index) => (
                        <Photo key={item.title} data={item} tag={"tableSetup"} index={index} showDate={false} selectImage={selectImage} />
                    ))}
                </div>
                {open &&
                    <PhotoPopup showDate={false} data={image} toggleOpen={toggleOpen} next={next} prev={prev} />
                }
            </section>
        </div>
    );
}
